import React from 'react';
import { DiffIconBox } from './DiffIcon.css';

interface IDiffIcon {
  diff: 1 | 2 | 3;
}

export const diffLib = {
  1: {
    name: 'BEGINNER',
    color: '#2e7d32',
  },
  2: {
    name: 'INTERMEDIATE',
    color: '#1976d2',
  },
  3: {
    name: 'EXPERT',
    color: '#d32f2f',
  }
}

const DiffIcon = (props: IDiffIcon): JSX.Element => {
  return (
    <DiffIconBox style={{backgroundColor: diffLib[props.diff].color}}>
      {diffLib[props.diff].name}
    </DiffIconBox>
  );
};

export default DiffIcon;